module.exports = __webpack_public_path__ + "img/promo.0f0f0dc6.png";